<template lang="pug">
  include ./../vuek/mixins.pug

  +b.page-main
    +e.container
      the-header
      the-first-text-section
      //- the-rating-section
    //- +e.full
    //-   +e.container
    //-     the-compare-section(v-if="lng === 'ua'")
    //-     the-compare-section-en(v-else)
    +e.container
      the-map-section
      the-table-section
      the-first-video-section
    +e.full
      +e.container
        the-analysis-section
    +e.container
      the-neighbors-section
    +e.full
      +e.container
        the-recommendations-section
    +e.container
      //- the-steps-section
      the-footer
</template>

<script>
import { mapGetters } from 'vuex';

import TheAnalysisSection from '@/components/TheAnalysisSection/TheAnalysisSection';
import TheCompareSection from '@/components/TheCompareSection/TheCompareSection';
import TheCompareSectionEn from '@/components/TheCompareSectionEN/TheCompareSectionEN';
import TheFirstTextSection from '@/components/TheFirstTextSection/TheFirstTextSection';
import TheFirstVideoSection from '@/components/TheFirstVideoSection/TheFirstVideoSection';
import TheFooter from '@/components/TheFooter/TheFooter';
import TheHeader from '@/components/TheHeader/TheHeader';
import TheMapSection from '@/components/TheMapSection/TheMapSection';
import TheNeighborsSection from '@/components/TheNeighborsSection/TheNeighborsSection';
import TheRatingSection from '@/components/TheRatingSection/TheRatingSection';
import TheRecommendationsSection from '@/components/TheRecommendationsSection/TheRecommendationsSection';
import TheStepsSection from '@/components/TheStepsSection/TheStepsSection';
import TheTableSection from '@/components/TheTableSection/TheTableSection';


export default {
  name: 'page-main',

  data() {
    return {

    };
  },

  computed: {
    ...mapGetters({
      lng: 'lng',
    }),
  },

  components: {
    TheAnalysisSection,
    TheCompareSection,
    TheCompareSectionEn,
    TheFirstTextSection,
    TheFirstVideoSection,
    TheFooter,
    TheHeader,
    TheMapSection,
    TheNeighborsSection,
    TheRatingSection,
    TheRecommendationsSection,
    TheStepsSection,
    TheTableSection,
  },
};
</script>


<style lang="scss">
.page-main {
  &__container {
    max-width: 1024px;
    margin: 0 auto;
    padding-left: 16px;
    padding-right: 16px;
  }

  &__full {
    background: white;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageMain.vue